<template>
    <div class="file-preview">
        <div class="file-preview-footer text-right">
            <button type="button" class="btn btn-danger" @click="close">Kapat</button>
        </div>
        <div class="file-preview-content">
            <div class="container" v-if="data && mutableViewer == 'eyp'" style="padding-top: 30px;">
                <div class="float-right">
                    Ver: 
                    {{data.Version}}
                </div>
                <h4>
                    {{data.FileName}}
                    <small class="text-muted">{{data.Size | prettyBytes}}</small>
                </h4>
                <div class="row">
                    <div class="col-6">
                        <div class="card">
                            <div class="card-header">Üstveri</div>
                            <div class="card-body">
                                <table class="table table-borderless table-sm ozet">
                                    <tbody>
                                        <tr>
                                            <td>Üstyazı</td>
                                            <td>:</td>
                                            <td>
                                                <!-- <button type="button" @click="download('ustyazi')" class="btn btn-link" style="padding:0;">{{data.Ustveri.DosyaAdi}}</button> -->
                                                <file-download-link :document="data.Ustyazi" :isOnlineView="isOnlineView" @download="downloadEypAttachment" @preview="showEypAttachment"></file-download-link>
                                                
                                            </td>
                                        </tr>
                                        <tr>
                                            <td>Tarih</td>
                                            <td>:</td>
                                            <td>{{data.Ustveri.Tarih | date }}</td>
                                        </tr>
                                        <tr>
                                            <td>Belge Tekil No</td>
                                            <td>:</td>
                                            <td>{{data.Ustveri.BelgeId}}</td>
                                        </tr>
                                        <tr>
                                            <td>Tekil Anahtar</td>
                                            <td>:</td>
                                            <td>{{data.Ustveri.OzId}}</td>
                                        </tr>
                                        <tr>
                                            <td>Belge No</td>
                                            <td>:</td>
                                            <td>{{data.Ustveri.BelgeNo}}</td>
                                        </tr>
                                        <tr>
                                            <td>Konu</td>
                                            <td>:</td>
                                            <td>{{data.Ustveri.Konu}}</td>
                                        </tr>
                                        <tr>
                                            <td>Güvenlik Derecesi</td>
                                            <td>:</td>
                                            <td>
                                                {{data.Ustveri.GuvenlikKodu | eypSecurityCode }}
                                                <div class="text-muted" v-if="data.Ustveri.GuvenlikDerecesiTarihi">({{data.Ustveri.GuvenlikDerecesiTarihi | date }})</div>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td>Oluşturan</td>
                                            <td>:</td>
                                            <td>
                                                <button @click="showOzne(data.Ustveri.Olusturan, 'Oluşturan Bilgileri')" class="btn btn-link" style="padding:0;">{{data.Ustveri.Olusturan.Adi}}</button>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td>Dağıtımlar</td>
                                            <td>:</td>
                                            <td>
                                                <button class="btn btn-link" style="padding:0; text-align:left;" @click="showOzne(d.Item, 'Dağıtım Bilgileri')" v-for="d in data.Ustveri.Dagitimlar" :key="d.KKK">
                                                    {{d.Item.Adi}}
                                                </button>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td>Ekler</td>
                                            <td>:</td>
                                            <td>
                                                <div v-for="d in data.Ustveri.Ekler" :key="d.Id">
                                                    <file-download-link :document="convertEypAttachmentToDocument(d)" :isOnlineView="isOnlineView" @download="downloadEypAttachment" @preview="showEypAttachment"></file-download-link>
                                                    <!-- <button @click="download(d.Id)" class="btn btn-link" style="padding:0; text-align:left;">
                                                        {{d.Ad}}
                                                    </button> -->
                                                </div>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                    <div class="col-6">
                        <div class="card" v-if="data.BelgeHedef && data.BelgeHedef.length" style="margin-bottom:16px;">
                            <div class="card-header">Belge Hedef</div>
                            <div class="card-body">
                                <div v-for="h in data.BelgeHedef" :key="h.Adi">
                                    <button class="btn btn-link" style="padding:0; text-align:left;" @click="showOzne(h, 'Belge Hedef Bilgileri')">
                                        {{h.Adi}}
                                    </button>
                                </div>
                            </div>
                        </div>
                        <div class="card">
                            <div class="card-header">Belge İmza</div>
                            <div class="card-body">
                                <div v-for="h in data.BelgeImza" :key="h.Adi">
                                    <button class="btn btn-link" style="padding:0; text-align:left;" @click="showOzne(h.Imzalayan, 'İmzacı Bilgileri')">
                                        {{h.Imzalayan.Adi}}
                                    </button>
                                </div>
                                <div v-if="!data.BelgeImza || data.BelgeImza.length == 0" class="text-center text-muted" style="font-style:italic;">
                                    İmza yok.
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="container-fluid" v-else-if="mutableViewer == 'office'">
                <div v-if="iframeUrl" class="text-center text-muted" >
                    <VueDocPreview :url="iframeUrl" type="office" :height="100" />
                </div>
                <div v-else class="text-center text-muted" style="padding:100px 0">
                    Yükleniyor...
                </div>
            </div>
            <div class="container-fluid" v-else-if="mutableViewer == 'text'">
                <div v-if="iframeUrl" class="text-muted" >
                    <VueDocPreview :url="iframeUrl" type="text" :height="80" />
                </div>
                <div v-else class="text-center text-muted" style="padding:100px 0">
                    Yükleniyor...
                </div>
            </div>
            <div class="container-fluid" v-else-if="mutableViewer == 'code'">
                <div v-if="iframeUrl" class="text-muted" >
                    <VueDocPreview :url="iframeUrl" type="code" language="xml" :height="80" />
                </div>
                <div v-else class="text-center text-muted" style="padding:100px 0">
                    Yükleniyor...
                </div>
            </div>
            
            <div class="container-fluid pdf-outer-container" v-else-if="mutableViewer == 'pdf'">
                <div v-if="iframeUrl" class="pdf-container">
                    <div>
                        <!-- NEW PDF VIEWER I HOPE -->
                            <PDFViewer :pdfUrl="iframeUrl" ref="pdfViewer"/>
                        <!-- Need to load a single page to get page count -->
                        <!-- <pdf style="display: none;" :src="pdfData"
                            @num-pages="pageCount2 = new Array($event)" /> -->
                        <!-- Actual document -->
                        <!-- <pdf v-for="(page, index) in pageCount2"
                            :key="index"
                            :src="pdfData"
                            :page="index + 1"
                            class="contract-container" /> -->
                    </div>
                </div>
                <div v-else class="text-center text-muted" style="padding:100px 0">
                    Yükleniyor...
                </div>
            </div>
            <div class="container-fluid" v-else-if="mutableViewer != 'eyp'">
                <iframe class="iframe" v-if="iframeUrl" :src="iframeUrl"></iframe>
                <div v-else class="text-center text-muted" style="padding:100px 0">
                    Yükleniyor...
                </div>
            </div>
            <div v-else-if="error" class="text-center text-danger" style="padding:100px 0">
                {{error.Message}}
                <div v-for="(e, i) in error.ModelState" :key="i">
                    <div v-for="(a, ai) in e" :key="ai">{{a}}</div>
                </div>
            </div>
            <div v-else class="text-center text-muted" style="padding:100px 0">
                Yükleniyor...
            </div>
            <!-- <code>{{file}}</code>
            <hr>
            <code>{{data}}</code> -->
        </div>

        <!-- ÖZNE PREVIEW -->
        <div v-if="ozne" class="modal fade show" style="display: block" tabindex="-1" role="dialog">
            <div class="modal-dialog modal-lg modal-dialog-centered">
                <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title">{{ozneTitle || "Detaylar" }}</h5>
                    <button type="button" class="close" data-dismiss="modal" aria-label="Kapat" @click="ozne = null">
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>
                <div class="modal-body">
                    <div class="row">
                        <div class="col">
                            <b>{{ozne.Kind | ozneKind}} Bilgileri</b>
                            <table class="table table-borderless table-sm ozet">
                                <tbody v-if="ozne.Kind == 'KurumKurulus'">
                                    <tr>
                                        <td>Adı</td>
                                        <td>:</td>
                                        <td>{{ozne.Adi}}</td>
                                    </tr>
                                    <tr title="Kurum Kimlik Kodu">
                                        <td>K. K. Kodu</td>
                                        <td>:</td>
                                        <td>{{ozne.KKK}}</td>
                                    </tr>
                                </tbody>
                                <tbody v-else-if="ozne.Kind == 'GercekSahis'">
                                    <tr title="T.C. Kimlik No">
                                        <td>T.C.K.N</td>
                                        <td>:</td>
                                        <td>{{ozne.TCKN}}</td>
                                    </tr>
                                    <tr>
                                        <td>Adı</td>
                                        <td>:</td>
                                        <td>{{ozne.Adi}}</td>
                                    </tr>
                                    <tr v-show="ozne.Unvan">
                                        <td>Unvan</td>
                                        <td>:</td>
                                        <td>{{ozne.Unvan}}</td>
                                    </tr>
                                </tbody>
                                <tbody v-else-if="ozne.Kind == 'TuzelSahis'">
                                    <tr title="T.C. Kimlik No">
                                        <td>Mersis No</td>
                                        <td>:</td>
                                        <td>{{ozne.MersisNo}}</td>
                                    </tr>
                                    <tr>
                                        <td>Id</td>
                                        <td>:</td>
                                        <td>{{ozne.Id}}</td>
                                    </tr>
                                    <tr>
                                        <td>Adı</td>
                                        <td>:</td>
                                        <td>{{ozne.Adi}}</td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                        <div class="col">
                            <b>İletişim Bilgileri</b>
                            <table class="table table-borderless table-sm ozet">
                                <tbody v-if="ozne.IletisimBilgisi">
                                    <tr v-if="ozne.IletisimBilgisi.Telefon">
                                        <td>Telefon</td>
                                        <td>:</td>
                                        <td>{{ozne.IletisimBilgisi.Telefon}}</td>
                                    </tr>
                                    <tr v-if="ozne.IletisimBilgisi.Telefon2">
                                        <td>Telefon 2</td>
                                        <td>:</td>
                                        <td>{{ozne.IletisimBilgisi.Telefon2}}</td>
                                    </tr>
                                    <tr v-if="ozne.IletisimBilgisi.EPosta">
                                        <td>E-Posta</td>
                                        <td>:</td>
                                        <td><a :href="'mailto:' + ozne.IletisimBilgisi.EPosta">{{ozne.IletisimBilgisi.EPosta}}</a></td>
                                    </tr>
                                    <tr v-if="ozne.IletisimBilgisi.Faks">
                                        <td>Faks</td>
                                        <td>:</td>
                                        <td>{{ozne.IletisimBilgisi.Faks}}</td>
                                    </tr>
                                    <tr v-if="ozne.IletisimBilgisi.Web">
                                        <td>Web</td>
                                        <td>:</td>
                                        <td><a :href="ozne.IletisimBilgisi.Web">{{ozne.IletisimBilgisi.Web}}</a></td>
                                    </tr>
                                    <tr v-if="ozne.IletisimBilgisi.Adres">
                                        <td>Adres</td>
                                        <td>:</td>
                                        <td>{{ozne.IletisimBilgisi.Adres}}</td>
                                    </tr>
                                    <tr v-if="ozne.IletisimBilgisi.Ilce">
                                        <td>İlçe</td>
                                        <td>:</td>
                                        <td>{{ozne.IletisimBilgisi.Ilce}}</td>
                                    </tr>
                                    <tr v-if="ozne.IletisimBilgisi.Il">
                                        <td>İl</td>
                                        <td>:</td>
                                        <td>{{ozne.IletisimBilgisi.Il}}</td>
                                    </tr>
                                    <tr v-if="ozne.IletisimBilgisi.Ulke">
                                        <td>Ülke</td>
                                        <td>:</td>
                                        <td>{{ozne.IletisimBilgisi.Ulke}}</td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
                <div class="modal-footer">
                    <button type="button" class="btn btn-outline-secondary" @click="ozne = null">Kapat</button>
                </div>
                </div>
            </div>
        </div>
        <!-- ÖZNE PREVIEW SONU -->
    </div>
</template>
<script>
import axios from 'axios'
import VueDocPreview from "vue-doc-preview";
import fileDownloadLink from '../components/FileDownloadLink.vue'
import PDFViewer from './PDFViewer.vue';

export default {
    components: {
      VueDocPreview,
    PDFViewer,
    fileDownloadLink
    },
    props: {
        file: {
            type: Object,
            required: true
        },
        viewer: {
            type: String,
            default: 'eyp'
        },
        isOnlineView: {
            type: Boolean,
            default: true
        }
    },
    data(){
        
        return {
            pageCount2: [],
            page: null,
            pageCount: 1,
            showAllPages: true,
            data: null,
            error: null,
            ozne: null,
            ozneTitle: null,
            iframeUrl: null,
            width : screen.width*0.6,
            subFileDetail:null,
            mutableFile: this.file,
            mutableViewer: this.viewer,
            pdfData: null,
        };
    },
    watch: {
    showAllPages() {
      this.page = this.showAllPages ? null : 1
    },
    },
    created(){
        document.getElementsByTagName('body')[0].style = 'overflow:hidden';

        switch(this.mutableViewer){
            case "eyp":
                axios.post('previeweyp/post', {
                    EntityId : this.mutableFile.EntityId,
                    DocumentId: this.mutableFile.Id,
                    EntityType: this.mutableFile.EntityType ?? "Job"
                }).then(x => {
                    this.data = x.data;
                })
                .catch(x => {
                    console.log('Önizleme verisi alınamadı.', x.response);
                    this.error = x.response.data;
                })
                break;
            case "pdf":
                this.getDownloadUrl()
                .then(x => {
                    console.log(x)
                    this.iframeUrl = x.data.Data.Url;
                    //this.getPdfData();
                })
                break;
            case "office":
            this.getDownloadUrl()
                .then(x => {
                    this.iframeUrl = x.data.Data.Url;
                })
                break;
            case "text":
            this.getDownloadUrl()
                .then(x => {
                    console.log(x)
                    this.iframeUrl = x.data.Data.Url;
                })
                break;
            case "code":
            this.getDownloadUrl()
                .then(x => {
                    console.log(x)
                    this.iframeUrl = x.data.Data.Url;
                })
                break;
            default:
                this.getDownloadUrl()
                .then(x => {
                    this.iframeUrl = this.viewerUrl + x.data.Data.Url;
                })
                break;
        }

        
    },
    destroyed(){
        document.getElementsByTagName('body')[0].style = '';
    },
    computed: {
        viewerUrl(){
            return this.mutableViewer == 'office365' ? 'https://view.officeapps.live.com/op/view.aspx?src=' : 'https://docs.google.com/gview?embedded=true&url=';
        }
    },
    methods:{
        getPdfData(){
            if(this.pdfData){
                return;
            }
            else {
                axios({
                    url: this.iframeUrl, //your url
                    method: 'GET',
                    responseType: 'blob', // important
                }).then((response) => {
                    
                    // create file link in browser's memory
                   // this.pdfData =  response.data;
                   new Response(response.data).arrayBuffer().then((d)=> {
                    this.pdfData = new Uint8Array(d);
                   });
                });
            }
        },
        createdCopy(){
            document.getElementsByTagName('body')[0].style = 'overflow:hidden';

            switch(this.mutableViewer){
                case "eyp":
                    axios.post('previeweyp/post', {
                        EntityId : this.mutableFile.EntityId,
                        DocumentId: this.mutableFile.Id,
                        EntityType: this.mutableFile.EntityType ?? "Job"
                    }).then(x => {
                        this.data = x.data;
                    })
                    .catch(x => {
                        console.log('Önizleme verisi alınamadı.', x.response);
                        this.error = x.response.data;
                    })
                    break;
                case "pdf":
                    this.getDownloadUrl()
                    .then(x => {
                        console.log("pdf",x)
                        this.iframeUrl = x.data.Data.Url;
                        //this.getPdfData();
                    })
                    break;
                case "office":
                this.getDownloadUrl()
                    .then(x => {
                        this.iframeUrl = x.data.Data.Url;
                    })
                    break;
                case "text":
                this.getDownloadUrl()
                    .then(x => {
                        console.log(x)
                        this.iframeUrl = x.data.Data.Url;
                    })
                    break;
                case "code":
                this.getDownloadUrl()
                    .then(x => {
                        console.log(x)
                        this.iframeUrl = x.data.Data.Url;
                    })
                    break;
                default:
                    this.getDownloadUrl()
                    .then(x => {
                        this.iframeUrl = this.viewerUrl + x.data.Data.Url;
                    })
                    break;
            }
        },
        handleDocumentRender() {
        this.isLoading = false
        this.pageCount = this.$refs.pdfRef.pageCount
        },
        close(){
            this.$emit('close');
        },
        showOzne(ozne, title){
            this.ozne = ozne;
            this.ozneTitle = title;
        },
        download(attachmentId, isSigned = false){
            // İndirilecek doküman için dinamik URL'i alır ve tarayıcıyı bu adrese yönlendirir.
            return axios
              .post(`/jobDocumentUrl/`, {
                  EntityId : this.mutableFile.EntityId,
                  DocumentId: this.mutableFile.Id,
                  IsSigned: isSigned,
                  AttachmentId: attachmentId,
                  EntityType: this.mutableFile.EntityType ?? "Job"
              })
              .then(x => {
                console.log("jobDocumentUrl Result:", x.data);
                window.open(x.data.Data.Url);
              })
              .catch(x => window.processErrorResponse(x, this));
        },
        convertEypAttachmentToDocument(data){
            var result = {...data};
            result.AttachmentId = data.Id;
            result.FileName = data.Ad;
            return result;
        },
        downloadEypAttachment(attachment, menuKey){
            // İndirilecek doküman için dinamik URL'i alır ve tarayıcıyı bu adrese yönlendirir.
            return axios
              .post(`/jobDocumentUrl/`, {
                  EntityId : this.mutableFile.EntityId,
                  DocumentId: this.mutableFile.Id,
                  AttachmentId: attachment.AttachmentId,
                  EntityType: this.mutableFile.EntityType ?? "Job"
              })
              .then(x => {
                console.log("jobDocumentUrl Result:", x.data);
                window.open(x.data.Data.Url+ (menuKey == 'view' ? "&view=true" : ""));
              })
              .catch(x => window.processErrorResponse(x, this));
        },

        showEypAttachment(document,type){
            var oldDoc = {...this.mutableFile};
            this.mutableFile = document;
            this.mutableViewer = type;
            this.mutableFile.DocumentId = oldDoc.Id;
            this.mutableFile.EntityId = oldDoc.EntityId;
            this.mutableFile.OldEntityType = oldDoc.EntityType;
            this.mutableFile.EntityType = "eyp";
            this.createdCopy();
        },
        getDownloadUrl(){
            var entityType = this.mutableFile.EntityType ?? "job";
            var url = "";
            var obj = { EntityId : this.mutableFile.EntityId };
            if(entityType == "job"){
                url = this.mutableFile.UnsignedFile ? `/jobDocumentUrl/` : `/job/createAttachmentUrl/`;
            
                if(this.mutableFile.UnsignedFile) {
                    obj.DocumentId = this.mutableFile.Id;
                } else {
                    obj.AttachmentId = this.mutableFile.Id;
                }
            }else if(entityType == "eyp"){
                url =  `/previeweyp/createDocumentUrl/`;
                obj.DocumentId = this.mutableFile.DocumentId;
                obj.AttachmentId = this.mutableFile.AttachmentId;
                obj.EntityType = this.mutableFile.OldEntityType;
            }
            else if(entityType == "Rem"){
                url = this.mutableFile.DocumentId ? `/rembox/createDocumentUrl/` : `/rembox/createAttachmentUrl/`;
                
                if(this.mutableFile.Id){
                    obj.EntityId = this.mutableFile.EntityId;
                    obj.AttachmentId = this.mutableFile.Id;
                }
            }
            return axios.post(url, obj);
        }
    }
}
</script>
<style scoped>
    .container-fluid{
        padding-right: 0px !important;
        padding-left: 0px !important;
    }
    .file-preview {
        position:fixed;
        top:0;
        right:0;
        bottom:0;
        left:0;
        background:#FFF;
    }

    .file-preview-content {
        position:fixed;
        right: 0;
        top:0;
        bottom: 0;
        left: 0;
        overflow: auto;
        z-index: 998;
    }

    .file-preview-footer {
        z-index: 999;
        position: fixed;
        right:0;
        left:0;
        padding: 8px;
        margin-right: 15px;
    }

    .iframe {
        position: fixed;
        left: 0;
        right: 0;
        width: 100%;
        top: 59px;
        bottom: 50px;
        height: calc(100% - 113px);
    }
    .pdf-container{
        width: 100vw;
        height: 100%;
        display: flex;
        justify-content: center;
    }
    .pdf-outer-container{
        background-color: #ccc;
        height: 100%;
        padding-top: 20px;
        padding-bottom: 20px;
    }
</style>